import { globalOptions } from 'Dictionaries/imports/importOptionsDictionary.js';
export const options = _.merge(
    {
        parameters: {
            create: {
                options: {
                    insert_new_records: {
                        title: window.i18n.__(
                            'Si un service de mon fichier n’existe pas dans Sellsy',
                        ),
                        values: [
                            {
                                value: 'Y',
                                label: window.i18n.__('Ajouter le service'),
                                description: window.i18n.__(
                                    'Le service du fichier est pris en compte et importé dans Sellsy.',
                                ),
                            },
                            {
                                value: 'N',
                                label: window.i18n.__('Ignorer et ne pas ajouter le service'),
                                description: window.i18n.__(
                                    'Le service du fichier est ignoré et n’est pas importé dans Sellsy.',
                                ),
                            },
                        ],
                    },
                },
            },
            update: {
                options: {
                    update_existing_records: {
                        title: window.i18n.__('Si un service de mon fichier existe dans Sellsy'),
                        values: [
                            {
                                value: 'Y',
                                label: window.i18n.__('Mettre à jour le service'),
                                description: window.i18n.__(
                                    'Le service identique du fichier trouvé par rapport au critère de comparaison renseigné est mis à jour dans Sellsy.',
                                ),
                            },
                            {
                                value: 'N',
                                label: window.i18n.__('Ignorer et ne pas mettre à jour le service'),
                                description: window.i18n.__(
                                    'Le service identique du fichier trouvé par rapport au critère de comparaison renseigné est ignoré et n’est pas mis à jour dans Sellsy.',
                                ),
                            },
                        ],
                    },
                },
            },
            description: window.i18n.__(
                "Cette section vous permet de déterminer le critère sur lequel nous allons déterminer si un service existe déjà dans vos données Sellsy"
            ),
        },
        identifiers: {
            service: {
                title: window.i18n.__('Critère de comparaison pour les services'),
                multiple: false,
                choices: [
                    {
                        value: 'reference',
                        label: window.i18n.__('Référence'),
                        description: window.i18n.__(
                            'Référence ou code du service unique dans le catalogue',
                        ),
                    },
                    {
                        value: 'id',
                        label: window.i18n.__('Identifiant service'),
                        description: window.i18n.__(
                            'Récupéré depuis un export Sellsy ou depuis le catalogue',
                        ),
                    },
                ],
            },
        },
    },
    globalOptions,
);
export const defaultOptions = {
    identifiers: {
        service: ['reference'],
    },
};
